<template>
  <div>
    <div class="employ_bar" @click="openAdd">
      <div>Add on cost</div>
      <div class="employ_bar__cost">
        <span>{{ cost ? (cost * 100).toFixed(2) : "0.00" }}%</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
        </svg>
       </div>

    </div>
    <div class="employ_indexBox">
      <div v-if="!load">
        <el-table
          :data="tableData"
          border
          class="roster_table fee_table"
          style="width: 100%"
        >
          <el-table-column
            prop="employeeName"
            align="left"
            width="260"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Employee Name"
          >
          </el-table-column>
          <el-table-column
            prop="salaryF"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Annual Salary"
          >
          </el-table-column>
          <el-table-column
            prop="days"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Working days per week"
          >
            <template slot-scope="scope">
              {{scope.row.days}} day<span v-if="scope.row.days !== 1
              && scope.row.days !== '1'">s</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="boo"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Is super included in the salary?"
          >
          </el-table-column>

          <el-table-column
            prop="address"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            width="260"
            label="Functions"
          >
            <template slot-scope="scope">
              <span class="functionBtn-pro" @click="editMsg(scope.row)"
                >Edit</span
              >
              <span
                class="functionBtn-pro danger-button"
                @click="del(scope.row)"
                >Delete</span
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <i v-if="load" class="el-icon-loading" style="font-size: 20px"></i>
            <div v-else style="font-size: 18px">No Data</div>
          </template>
        </el-table>
        <div class="ros_footerPage">
          <el-pagination
            class="my_pageSel"
            layout="prev, pager, next"
            :page-size="10"
            @current-change="changePage"
            :current-page.sync="page"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 弹框-->
      <el-dialog
        :title="addFlag ? 'Add new salary employee' : dioTitle"
        :visible.sync="empioyeeDio"
        :modal-append-to-body="true"
        :show-close="false"
        class="empioyeeDio"
        :close-on-click-modal="false"
        width="840px"
        center
      >
        <div>
          <div class="tag_tit">Employee Name</div>
          <el-input
            v-model="expenseName"
            maxlength="100"
            class="borderNone"
          ></el-input>

          <div class="checkBox_list_new clear">
            <div class="venue_checkBox2">
              <div class="tag_tit">Weekly salary</div>
              <el-input
                v-model="monthlyFees"
                maxlength="10"
                class="borderNone pad-lft-40"
                @input="
                  monthlyFees = monthlyFees
                   .replace(/[^\d.]/g, '')
                   .replace(/^\./g, '')
                   .replace(/\.{2,}/g, '')
                   .replace('.', '$#$')
                   .replace(/\./g, '')
                   .replace('$#$', '.')
                   .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                "
                @change="calculateAnnual()"
              ></el-input>
              <span class="dollar">$</span>
            </div>
            <div class="venue_checkBox2">
              <div class="tag_tit">Annual Base Salary</div>
              <el-input
                v-model="annualFees"
                maxlength="10"
                class="borderNone pad-lft-40"
                @input="
                  annualFees = annualFees
                   .replace(/[^\d.]/g, '')
                   .replace(/^\./g, '')
                   .replace(/\.{2,}/g, '')
                   .replace('.', '$#$')
                   .replace(/\./g, '')
                   .replace('$#$', '.')
                   .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                "
                @change="calculateWeekly()"
              ></el-input>
              <span class="dollar">$</span>
            </div>
          </div>

          <div v-if="!isFixedCost" class="suffix-customize-days">
            <div class="tag_tit_no_top">Working days per week</div>
            <el-input
              v-model="workDay"
              maxlength="1"
              @input="detectWorkDay"
              class="borderNone"
              suffix-icon="day(s)"
            >
            </el-input>
          </div>

          <div class="tag_tit" style="margin: 0 0 20px 0">
            Is super included in the salary?
          </div>
          <div class="checkBox_list_new clear">
            <div class="venue_checkBox2">
              <span
                v-if="type != 1"
                @click="setType(1)"
                class="venue_check"
              ></span>
              <span v-else class="venue_checked"></span>
              <span class="venueCheckBox_msg">Yes</span>
            </div>
            <div class="venue_checkBox2">
              <span
                v-if="type != 0"
                @click="setType(0)"
                class="venue_check"
              ></span>
              <span v-else class="venue_checked"></span>
              <span class="venueCheckBox_msg">No</span>
            </div>
          </div>


          <div class="tag_tit" style="margin: 0 0 20px 0;">
            This salary a fixed cost?
          </div>
          <div class="checkBox_list_new clear">
            <div class="venue_checkBox2">
              <span
                v-if="isFixedCost != 1"
                @click="setFixedCost(1)"
                class="venue_check"
              ></span>
              <span v-else class="venue_checked"></span>
              <span class="venueCheckBox_msg">Yes</span>
            </div>
            <div class="venue_checkBox2">
              <span
                v-if="isFixedCost != 0"
                @click="setFixedCost(0)"
                class="venue_check"
              ></span>
              <span v-else class="venue_checked"></span>
              <span class="venueCheckBox_msg">No</span>
            </div>
          </div>

          <template v-if="isFixedCost">
            <div class="tag_tit" style="margin: 0 0 20px 0;">
              Select working days
            </div>
            <div class="checkBox_list_new venue_checkBoxList clear">

              <div v-for="(value, key, i) in workingDays" @click="workingDays[key] = !workingDays[key]" :key="i" class="venue_checkBox2">
                <span
                  v-if="!value"
                  class="venue_check"
                ></span>
                <span v-else class="venue_checked"></span>
                <span class="venueCheckBox_msg">{{key}}</span>
              </div>

            </div>
          </template>



        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="empioyeeDio = false" class="cardCanBtn"
            >Cancel</el-button
          >
          <el-button @click="confirm" class="cardConBtn">Confirm</el-button>
        </span>
      </el-dialog>

      <!-- 弹框-->
      <el-dialog
        title=""
        :visible.sync="delDio"
        :modal-append-to-body="false"
        :show-close="false"
        class="delEmployDio"
        :close-on-click-modal="false"ve
        width="840px"
        center
      >
        <div class="delMsg-tit2">
          Are you sure you want to delete {{ this.employeName }}?
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delDio = false" class="cardCanBtn"
            >Cancel</el-button
          >
          <el-button @click="delConfirm" class="cardConBtn">Delete</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="Add on Cost"
        :visible.sync="extraDio"
        :modal-append-to-body="false"
        :show-close="false"
        class="editCardDio"
        :close-on-click-modal="false"
        width="840px"
        center
      >
        <div>
          <div class="tag_tit_new">Add on Cost</div>
          <el-input
            v-model="costValue"
            maxlength="6"
            class="borderNone"
            @input="handleCostInput"
          >
            <span slot="suffix" class="increaseIcon_new">%</span>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="(extraDio = false), (costValue = '')"
            class="cardCanBtn"
            >Cancel</el-button
          >
          <el-button class="cardConBtn" @click="confirmUpdateCost"
            >Confirm</el-button
          >
        </span>
      </el-dialog>
    </div>
    <pin-dialog :visible="visible" :closeEscape="false" @receive="receiveEvents" />

		<el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
  </div>


</template>

<script>
import api from "../../api/api";
import { mapMutations } from "vuex";
import pinDialog from "../common/pin";
import freeTrialNotice from '@/components/modal/freeTrialNotice';
import Utils from "../../utils/utils";
export default {
  props: {
    addFlag: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      employeName: 0,
      workDay: '',
      val: "",
      load: false,
      disabledDio: false,
      active: 0,
      tableData: [],
      empioyeeDio: false,
      delDio: false,
      dioTitle: "Edit salary employee",
      page: 1,
      size: 10,
      total: 0,
      value: "",
      fromD: 0,
      type: 1,
      isFixedCost: 0,
      expenseName: "",
      monthlyFees: "",
      annualFees: "",
      curId: "",
      cost: null,
      workingDays: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false
      },
      extraDio: false,
      costValue: "",
      updating: false,

      rate: 10.5,

      visible: false,


			isPro: false,
      isDoneLoad: false,
      venueDiscountDetailsPojo: null,
      isTrialEnd: false,
      tandaFlag: false
    };
  },
  created() {
    // if (!this.$route.params.auth && this.venueType === "2") {
    //   this.visible = true;
    //   return;
    // }
    var isSingleAccount = sessionStorage.getItem('isSingleAccount')
    var isPinNeeded = sessionStorage.getItem('isPinNeeded')
    if (isSingleAccount == '1' && isPinNeeded == '1') {
      this.visible = true
    } else {
      this.init();
    }
  },

  mounted() {
    this.$root.$on('isPro', (isPro, others) => {
			this.isPro = isPro
			this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
      this.tandaFlag = others.tandaFlag
      if (this.$route.path == '/rosterAndemployee' && others.tandaFlag) {
        this.$router.push('/rosterAndlabourlabour')
      }
		})
  },
  methods: {
    detectWorkDay() {
      this.workDay = this.workDay.replace(/[^\d]/g,'')
      if ( this.workDay && Number(this.workDay) > 7)
        this.workDay = ''
      if (this.workDay === '0')
        this.workDay = ''
    },
    handleCostInput() {
      // Allow digits, decimal point, and negative sign
      let value = this.costValue.replace(/[^\d.-]/g, '');
      
      // Handle negative sign - only allow at the beginning
      if (value.includes('-')) {
        const negativeIndex = value.indexOf('-');
        if (negativeIndex !== 0) {
          value = value.replace(/-/g, '');
        } else {
          // Keep only the first negative sign
          value = '-' + value.substring(1).replace(/-/g, '');
        }
      }
      
      // Handle decimal point - only allow one
      const decimalCount = (value.match(/\./g) || []).length;
      if (decimalCount > 1) {
        const firstDecimalIndex = value.indexOf('.');
        value = value.substring(0, firstDecimalIndex + 1) + value.substring(firstDecimalIndex + 1).replace(/\./g, '');
      }
      
      // Prevent multiple leading zeros (except for 0.xx)
      if (value.match(/^0\d/) && !value.match(/^0\./)) {
        value = value.substring(1);
      }
      
      // Limit to 2 decimal places
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }
      
      // Check if value exceeds 100 (or -100 for negative values)
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue) && Math.abs(numericValue) >= 100) {
        value = '';
      }
      
      this.costValue = value;
    },
    openAdd() {
      this.extraDio = true
      this.costValue = (this.cost * 100).toFixed(2)
    },
    init() {
      this.getList();
      api.onCost({
        callback: (res) => {
          let { code, data, message } = res.data;
          if (code == 0) {
            this.cost = data;
          } else {
            Utils.alert2("", message, "error");
          }
        },
      });
    },
    receiveEvents(type) {
      this.visible = false;
      if (type === "confirm") {
        this.init();
      }
    },
    // 输入周薪，输入完成，鼠标失去焦点，开始计算年薪
    calculateAnnual() {
      var that = this;
      // 如果当前super 为no，年薪 = 周薪 / 7 * 365
      if (that.type === 0) {
        let temp = ((Number(that.monthlyFees) * 100) / 7) * 365;
        that.annualFees = (temp / 100).toFixed(2);
        // console.log(that.annualFees);
      } else {
        // 如果当前super 为yes，年薪 = (365 * 周薪) / (7 * (1 - 0.105))
        let temp = Number(that.monthlyFees) * 100;
        let fenzi = temp * 365;
        let fenmu = 7 * (100 - that.rate);
        that.annualFees = (fenzi / fenmu).toFixed(2);
      }
    },
    calculateWeekly() {
      var that = this;
      // 如果当前super 为no，周薪 = 年薪 / 365 * 7
      if (that.type === 0) {
        let temp = (Number(that.annualFees) / 365) * 7 * 100;
        that.monthlyFees = (temp / 100).toFixed(2);
      } else {
        // 如果当前super 为yes
        let temp = Number(that.annualFees);
        let fenzi = temp * (100 - that.rate);
        let fenmu = 365 * 100;
        that.monthlyFees = ((fenzi / fenmu) * 7).toFixed(2);
      }
    },
    setType(t) {
      if (t === this.type) return;
      // 由no 变为 yes, 周薪不变，重新计算年薪
      this.type = t;
      this.calculateAnnual();
    },
    setFixedCost(value) {
      if (value === this.isFixedCost) return;
      this.isFixedCost = value;
    },
    confirmUpdateCost() {
      if (this.updating) return;
      this.updating = true;
      api.updateCost({
        params: this.costValue / 100,
        callback: (res) => {
          let { code, data, message } = res.data;
          this.updating = false;
          this.extraDio = false;
          if (code == 0) {
            this.cost = this.costValue / 100;
          } else {
            Utils.alert2("", message, "error");
          }
        },
      });
    },
    ...mapMutations(["setOtherFrom", "setFresh", "setEmployeeFresh"]),
    confirmD() {
      let pat = {
        id: this.curId,
      };
      this.tableData = [];
      api.changeEmployeeState(pat, (res) => {
        this.disabledDio = false;
        this.val = "";
        let { code, data, message } = res.data;
        if (code == 0) {
          this.getList();
          this.setFresh({ data: true });
        } else {
          Utils.alert("", message, "error");
        }
      });
    },
    editMsg(val) {
      console.log('val: ', val);
      // 修改弹窗
      this.curId = val.id;
      let pat = {
        id: val.id,
      };
      this.empioyeeDio = true;
      this.type = val.isSuperIncludedInTheSalary;
      this.isFixedCost = val.isFixedCost ? val.isFixedCost : 0;
      // this.name = data.name
      this.expenseName = val.employeeName;
      this.monthlyFees = JSON.stringify(val.employeeSalary);
      this.annualFees = JSON.stringify(val.salary);
      this.workDay = val.days ? JSON.stringify(val.days) : ''
      this.workingDays = val.workingDays
      // this.calculateAnnual();
      if (val.workingDays) {
        this.workingDays = val.workingDays;
      }
    },
    del(val) {
      this.curId = val.id;
      this.delDio = true;
      this.employeName = val.employeeName;
    },
    delConfirm() {
      api.deleteEmployeeNew({
        params: this.curId,
        callback: (res) => {
          let { code, data, message } = res.data;
          if (code == 0) {
            this.delDio = false;
            this.getList();
            this.setFresh({ data: true });
            Utils.alert2("", "Successfully deleted", "success");
          } else {
            Utils.alert2("", message, "error");
          }
        },
      });
    },
    closeOrLogoutVenue(isSubscribe) {
      if (isSubscribe) {
        this.isTrialEnd = false
        return
      }
      if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
        this.$root.$emit('logout-venue')
      } else {
        const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
        if (isContUsingTrial == '0') {
          sessionStorage.setItem('isContUsingTrial', '1')
        }
        this.isTrialEnd = false
      }
    },
    changePage(page) {
      this.page = page;
      this.getList();
    },
    getList() {
      this.load = true;
      let pat = {
        pageNum: this.page,
        pageSize: this.size,
      };
      api.getEmployeeNewList({
        params: pat,
        callback: (res) => {
          this.load = false;
          let { code, data, message } = res.data;
          if (code == 0) {
            this.tableData = data.list;
            this.total = data.total;
            this.tableData.forEach((item) => {
              // console.log(item);
              // item.salary = '$' + Utils.formatSplit(item.annualSalary)

              /*if (item.isSuperIncludedInTheSalary === 0) {
                let temp = ((item.employeeSalary * 100) / 7) * 365;
                let temp_salary = (temp / 100).toFixed(2);
                item.salary = "$" + Utils.formatSplit(temp_salary);
              } else {
                let temp = item.employeeSalary * 100;
                let fenzi = temp * 365;
                let fenmu = 7 * (100 - this.rate);
                let temp_salary = (fenzi / fenmu).toFixed(2);
                item.salary = "$" + Utils.formatSplit(temp_salary);
              }*/

              // item.salary = Utils.formatMoney5(item.annualSalary)
              item.salaryF = Utils.formatMoney5(item.annualSalary)

              item.salary = item.annualSalary

              item.boo = item.isSuperIncludedInTheSalary === 0 ? "No" : "Yes";
            });
          } else {
            Utils.alert2("", message, "error");
          }
        },
      });
    },
    confirm() {
      // 221.08.11 delete last name validation
      if (!this.expenseName || !this.monthlyFees || !this.annualFees) {
        Utils.alert2("", "Imperfect information", "error");
        return;
      }
      let pat = {
        isSuperIncludedInTheSalary: this.type,
        employeeName: this.expenseName,
        // monthlyFees: this.monthlyFees,
        isFixedCost: this.isFixedCost,
        annualSalary: Number(this.annualFees),
        employeeSalary: Number(this.monthlyFees),
        days: Number(this.workDay),
        workingDays: this.workingDays
      };
      if (this.addFlag) {
        api.addEmployeeNew({
          params: pat,
          callback: (res) => {
            let { code, data, message } = res.data;
            if (code == 0) {
              this.empioyeeDio = false;
              this.getList();
              Utils.alert2("", "Successfully saved", "success");
            } else {
              Utils.alert2("", message, "error");
            }
          },
        });
      } else {
        pat.id = this.curId;
        api.updateEmployeeNew({
          params: pat,
          callback: (res) => {
            let { code, data, message } = res.data;
            if (code == 0) {
              this.empioyeeDio = false;
              this.getList();
              Utils.alert2("", "Successfully saved", "success");
              // 刷新右上角
              this.setFresh({ data: true });
            } else {
              Utils.alert2("", message, "error");
            }
          },
        });
      }
    },
  },
  components: {
    pinDialog,
    freeTrialNotice: freeTrialNotice
  },
  watch: {
    empioyeeDio(n, o) {
      var that = this;
      if (!n) {
        setTimeout(() => {
          this.setOtherFrom({ boo: true, name: "" });
          this.$emit("close");
        }, 200);
        that.type = 1;
        that.isFixedCost = 0;
        that.name = "";
        that.expenseName = "";
        that.monthlyFees = "";
        that.annualFees = "";
        that.workingDays = {
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false
        };
      }
    },
    addFlag(n, o) {
      if (n) {
        this.empioyeeDio = true;
        this.workDay = ''
      }
    },
    isEmployeeFresh(n, o) {
      if (n === true) {
        this.setEmployeeFresh({ data: false });
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss">
.tag_tit_new {
  height: 16px;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-color);
  line-height: 16px;
  margin: 10px 0 20px 0;
}
.increaseIcon_new {
  font-size: 22px;
  line-height: 50px;
  margin-right: 5px;
}

.employ_bar {
  width: 100%;
  height: 70px;
  background: var(--background-color-3);
  margin-top: 35px;
  padding-left: 35px;
  box-sizing: border-box;
  width: 100%;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: var(--text-color);
  line-height: 70px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-content: center;
  &__cost {
    padding: 0px 20px;
    color: var(--text-color);
    display: flex;
    align-items: center;
    align-content: center;
    gap: 30px;
  }

}
.employ_indexBox {
  width: 100%;
  margin: 30px 0 35px 0;
  .employ_indexBoxTop {
    display: flex;
    width: 280px;
    height: 60px;
    box-sizing: border-box;
    align-items: center;
    background-color: var(--background-color-3);
    margin-bottom: 30px;
    .employ-active-box {
      width: 140px;
      box-sizing: border-box;
      height: 100%;
      font-size: 20px;
      font-weight: 600;
      color: var(--text-color);
      line-height: 60px;
      text-align: center;
      cursor: pointer;
    }
    .isActive {
      background: var(--primary-color) !important;
    }
  }
  .ros_footerPage {
    display: flex;
    justify-content: center;
  }
  .functionBtn-pro {
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: var(--background-color-3);
    border: 1px solid var(--secondary-color);
    color: var(--secondary-color);
    margin-right: 10px;
    &:last-child {
      margin-right: 0px;
    }
  }
  .danger-button {
    color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
  }
  .status-round {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #3bd578;
    border-radius: 50%;
  }
  .status-round-err {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: var(--primary-color);
    border-radius: 50%;
  }
  .hoilday-box {
    display: inline-block;
    width: 90px;
    height: 24px;
    background: var(--primary-color);
    border: 1px solid var(--primary-color);
    color: var(--text-color);
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    margin-left: 10px;
  }

  .tag_tit {
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: var(--text-color);
    line-height: 16px;
    margin: 30px 0 10px 0;
  }
  .tag_tit_no_top{
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: var(--text-color);
    line-height: 16px;
    margin: 0px 0 10px 0;
  }
  .suffix-customize-days{
    margin-bottom: 30px;
  }
  .checkBox_list_new {
    // display: flex;
    // height: 40px;
    align-items: center;
  }

  .venue_checkBoxList {
    display: flex !important;
    align-items: center;
  }
  .venue_checkBox2 {
    width: 355px;
    float: left;
    margin-bottom: 30px;
    // margin-right: 319px;
    position: relative;
    .dollar {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-color);
      line-height: 50px;
      position: absolute;
      left: 20px;
      top: 55px;
    }
    .venue_check {
      display: inline-block;
      width: 16px;
      height: 16px;
      box-sizing: border-box;
      background: var(--background-color);
      border-radius: 50%;
      border: 1px solid rgba(95, 95, 95, 1);
      margin-right: 10px;
      cursor: pointer;
    }
    .venue_checked {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("../../../static/img/Shape.png");
      background-size: cover;
      border-radius: 50%;
      background-repeat: no-repeat;
      margin-right: 10px;
      cursor: pointer;
    }
    .venueCheckBox_msg {
      width: 360px;
      height: 28px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      color: var(--text-color);
      line-height: 28px;
      text-transform: capitalize !important;
    }
    &:nth-child(2) {
      float: right;
    }
  }



  .increaseIcon {
    line-height: 40px;
    font-size: 18px;
    color: var(--text-color);
    &:first-child {
      margin-right: 20px;
    }
    &:last-child {
      margin-left: 20px;
    }
  }

  .delMsg-tit2 {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
    line-height: 33px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rosterAndLabour/employee_new.vue